import { Button, Form, Input } from "antd";
import { FC } from "react";
import { creditCardSVG, masterCardSVG } from "../../assets/SVGs/SVGs";

interface CreditCardFormProps {
  paymentDetails: {
    cardNumber: string;
    name: string;
    cvv: string;
    expiry: string;
  };
  setPaymentDetails: React.Dispatch<
    React.SetStateAction<{
      cardNumber: string;
      name: string;
      cvv: string;
      expiry: string;
    }>
  >;
}

const CreditCardForm: FC<CreditCardFormProps> = ({
  paymentDetails,
  setPaymentDetails,
}) => {
  const handleChange = (name: string, value: string) => {
    setPaymentDetails({
      ...paymentDetails,
      [name]: value,
    });
  };
  return (
    <div className="  max-w-[500px] mx-auto bg-[#FBFBFF] p-2 rounded">
      <Form layout="vertical">
        <Form.Item
          colon={false}
          required={false}
          label="رقم الكارت"
          name="cardNumber"
          rules={[
            {
              required: true,
              message: "يجب عليك ادخال رقم الكارت",
            },
          ]}
        >
          <Input
            className=" p-1 h-10"
            onKeyDown={(e) => {
              if (
                /[^0-9]/.test(e.key) &&
                !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(
                  e.key
                )
              ) {
                e.preventDefault();
              }
            }}
            value={paymentDetails.cardNumber}
            onChange={(e) => handleChange("cardNumber", e.target.value)}
            placeholder={`5261   4141   0151   8472`}
            maxLength={16}
            prefix={
              <>
                {creditCardSVG}
                {masterCardSVG}
              </>
            }
          />
        </Form.Item>
        <Form.Item
          colon={false}
          required={false}
          label="اسم حامل الكارت"
          name="name"
          rules={[
            {
              required: true,
              message: "يجب عليك ادخال اسم حامل الكارت",
            },
          ]}
        >
          <Input
            className=" p-1 h-10"
            value={paymentDetails.cardNumber}
            onChange={(e) => handleChange("name", e.target.value)}
            placeholder={`John Doe`}
          />
        </Form.Item>
        <div className="flex justify-between gap-3">
          <Form.Item
            className="w-full"
            colon={false}
            required={false}
            label="CVV / CVC"
            name="cvv"
            rules={[
              {
                required: true,
                message: "يجب عليك ادخال رقم CVV / CVC",
              },
              {
                min: 3,
                max: 3,
                message: "يجب عليك ادخال 3 ارقام",
              },
            ]}
          >
            <Input
              className=" p-1 h-10"
              onKeyDown={(e) => {
                if (
                  /[^0-9]/.test(e.key) &&
                  !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(
                    e.key
                  )
                ) {
                  e.preventDefault();
                }
              }}
              value={paymentDetails.cvv}
              onChange={(e) => handleChange("cvv", e.target.value)}
              placeholder={`999`}
              maxLength={3}
            />
          </Form.Item>
          <Form.Item
            className="w-full"
            colon={false}
            required={false}
            label="الصلاحية"
            name="expiry"
            rules={[
              {
                required: true,
                message: "يجب عليك ادخال الصلاحية",
              },
              {
                min: 5,
                max: 5,
                message: "يجب عليك ادخال 5 ارقام",
              },
            ]}
          >
            <Input
              className=" p-1 h-10"
              onKeyDown={(e) => {
                if (
                  /[^0-9]/.test(e.key) &&
                  ![
                    "Backspace",
                    "Delete",
                    "ArrowLeft",
                    "ArrowRight",
                    "/",
                  ].includes(e.key)
                ) {
                  e.preventDefault();
                }
              }}
              value={paymentDetails.cvv}
              onChange={(e) => handleChange("expiry", e.target.value)}
              placeholder={`07/25`}
              maxLength={5}
            />
          </Form.Item>
        </div>
        <div>
          <Button type="primary" className="w-full " htmlType="submit">
            ادفع 999 <small className="text-xs mx-1">ريال سعودي</small>
          </Button>
        </div>
      </Form>
      <div></div>
    </div>
  );
};

export default CreditCardForm;
